import {
    Autocomplete,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    Link,
    MenuItem,
    TextField,
    Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import GayrimenkulBulPopUp from "../../../components/OB/PopUp";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { araziBasvuruValidationSchema } from "../../../validations/EmlakBasvuru";
import AraziTuruAPI from "../../../apis/OB/Get/AraziTuruAPI";
import AraziBasvurusave from "../../../apis/OB/SaveApi/AraziBasvurusave";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import SessionStorageService from "../../../services/StorageService";
import CustomTextField from "../../../components/OB/required-text-field";
import MahalleListeAPI from "../../../apis/OB/Get/MahalleListeAPI";
import SuSabitBilgiGetAPI from "../../../apis/OB/Get/SuSabitBilgiGetAPI";
import NumaratajKapiListeAPI from "../../../apis/OB/Get/NumaratajKapiListeAPI";
import AboneTipiListeAPI from "../../../apis/OB/Get/AboneTipiListeAPI";
import AkilliSayacListeAPI from "../../../apis/OB/Get/AkilliSayacListeAPI";
import SayacMarkaListeAPI from "../../../apis/OB/Get/SayacMarkaListeAPI";
import SayacYeriListeAPI from "../../../apis/OB/Get/SayacYeriListeAPI";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import KullanimSekliAPI from "../../../apis/OB/Get/KullanimSekliAPI";
import CtvKriterBulAPI from "../../../apis/OB/Get/CtvKriterBulAPI";
import YeniAbonelikBasvuruAPI, { YeniAbonelikSaveRequest } from "../../../apis/OB/SaveApi/YeniAbonelikBasvuruAPI";
import { showToast } from "../../../helpers/ToastifyHelper";
import { useNavigate } from "react-router";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import { Clear } from "@mui/icons-material";
import Recaptcha from "../../../components/Recaptcha";
import { toast } from "react-toastify";
import DysAPI from "../../../apis/DysAPI";
import WebSabitler from "../../../apis/WebSabitler";
import CloseIcon from "@mui/icons-material/Close";

const YeniAbonelik = () => {

    const focusInvalidInput = () => {
        if (selectedBolgeKodu == -1) {
            (document.querySelector(`[name=bolgeKodu]`) as HTMLElement).focus();
        } else if (selectedMahalleKodu == -1) {
            (document.querySelector(`[name=mahalleKodu]`) as HTMLElement).focus();
        } else if (selectedCaddeSokak == -1) {
            (document.querySelector(`[name=caddeSokakKodu]`) as HTMLElement).focus();
        } else if (kapiNo == -1) {
            (document.querySelector(`[name=kapiNo]`) as HTMLElement).focus();
        } else if (selectedAboneTipiKodu == -1) {
            (document.querySelector(`[name=aboneTipiKodu]`) as HTMLElement).focus();
        } else if (selectedSayacMarkaKodu == -1) {
            (document.querySelector(`[name=sayacMarkaKodu]`) as HTMLElement).focus();
        } else if (daskPoliceBilgisi == 1 && daskPoliceNo == "") {
            (document.querySelector(`[name=daskPoliceNo]`) as HTMLElement).focus();
        } else if (daskPoliceBilgisi == 1 && daskPoliceBaslangicTarihi == null) {
            (document.querySelector(`[name=daskPoliceBaslangicTarihi]`) as HTMLElement).focus();
        } else if (daskPoliceBilgisi == 1 && daskPoliceBitisTarihi == null) {
            (document.querySelector(`[name=daskPoliceBitisTarihi]`) as HTMLElement).focus();
        }
    }

    const recaptchaRef = useRef<any>(null);
    const [recaptchaPassed, setRecaptchaPassed] = useState(false);
    const [recaptchaError, setRecaptchaError] = useState(false);

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupAciklama, setPopupAciklama] = useState("");
    const [kayitBasarili, setKayitBasarili] = useState(false);
    const [araziTuruList, setAraziTuruList] = useState<any[]>([]);
    const closePopupSonuc = () => {
        setIsPopupVisible(false);
        setPopupAciklama("");
    };

    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [mahalleListe, setMahalleListe] = useState<any[]>([]);
    const [caddeListe, setCaddeListe] = useState<any[]>([]);
    const { yilListe, bolgeListe } = useContext(ConstantAPISContext);
    const [numaratajKapiListeDatas, setNumaratajKapiListeDatas] = useState<any[]>([]);
    const [aboneTipiDatas, setAboneTipiDatas] = useState<any[]>([]);
    const [akilliSayacMarkaDatas, setAkilliSayacMarkaDatas] = useState<any[]>([]);
    const [sayacMarkaDatas, setSayacMarkaDatas] = useState<any[]>([]);
    const [sayacYeriDatas, setSayacYeriDatas] = useState<any[]>([]);
    const [kullanimSekliDatas, setKullanimSekliDatas] = useState<any[]>([]);
    const [kriterBulAPIResponse, setKriterBulAPIResponse] = useState<any>();

    const [selectedBolgeKodu, setSelectedBolgeKodu] = useState<number>(-1);
    const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number>(-1);
    const [selectedCaddeSokak, setSelectedCaddeSokak] = useState<number>(-1);
    const [kapiNo, setKapiNo] = useState<number>(-1);
    const [selectedAboneTipiKodu, setSelectedAboneTipiKodu] = useState<any>(-1);
    const [selectedSayacTuru, setSelectedSayacTuru] = useState<any>(-1);
    const [selectedKullanimSekliKodu, setSelectedKullanimSekliKodu] = useState<any>(-1);
    const [ada, setAda] = useState("");
    const [parsel, setParsel] = useState("");
    const [altKapiNo, setAltKapiNo] = useState("");
    const [daireNo, setDaireNo] = useState("");
    const [altDaireNo, setAltDaireNo] = useState("");
    const [blokNo, setBlokNo] = useState("");
    const [katNo, setKatNo] = useState("");
    const [siteApartmanAdi, setSiteApartmanAdi] = useState("");
    const [pafta, setPafta] = useState("");
    const [damgaYili, setDamgaYili] = useState<any>(-1);
    const [selectedSayacMarkaKodu, setSelectedSayacMarkaKodu] = useState<any>(-1);
    const [sayacSeriNo, setSayacSeriNo] = useState("");
    const [kriterKodu, setKriterKodu] = useState<any>();
    const [m2, setM2] = useState("");
    const [ogrenciSayisi, setOgrenciSayisi] = useState("");
    const [koltukSayisi, setKoltukSayisi] = useState("");
    const [personelSayisi, setPersonelSayisi] = useState<any>("");
    const [yatakSayisi, setYatakSayisi] = useState("");
    const [daskPoliceNo, setDaskPoliceNo] = useState<any>("");
    const [daskPoliceBaslangicTarihi, setDaskPoliceBaslangicTarihi] = useState<any>();
    const [aciklama, setAciklama] = useState<any>("");
    const [daskPoliceBilgisi, setDaskPoliceBilgisi] = useState<any>(2);
    const [isLoad, setIsLoad] = useState(true);
    const [userControlPopup, setUserControlPopup] = useState(false);
    const user = SessionStorageService.getUserInfo()

    const [documents, setDocuments] = useState<any[]>([]);
    const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
    const documentTableRef = useRef<HTMLDivElement | null>(null);

    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const [mesafeliSozlesmeBase64, setMesafeliSozlesmeBase64] = useState<string | null>(null);
    const [sozlesmeOnaylandi, setSozlesmeOnaylandi] = useState<boolean>(false);
    const [sozlesmePopupOpen, setSozlesmePopupOpen] = useState<boolean>(false);
    const [sozlesmePdfUrl, setSozlesmePdfUrl] = useState<string | null>(null);
    const [sozlesmeScrolledToBottom, setSozlesmeScrolledToBottom] = useState<boolean>(false);

    const handleSozlesmeScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollHeight - scrollTop - clientHeight < 50) {
            setSozlesmeScrolledToBottom(true);
        }
    };

    const handleCloseSozlesmePopup = () => {
        setSozlesmePopupOpen(false);
        setSozlesmeScrolledToBottom(false);
        if (sozlesmePdfUrl) {
            window.URL.revokeObjectURL(sozlesmePdfUrl);
            setSozlesmePdfUrl(null);
        }
    };

    const handleUpdateDocuments = (updatedDocuments: any) => {
        setDocuments(updatedDocuments);
    };

    useEffect(() => {
        setDocsLoaded(false);

        DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 300 })
            .then((res: any) => {
                console.log("Belge listesi response:", res.data);

                const list = (res?.data ?? []).map((b: any, idx: number) => {
                    const zorunlu = (b.zorunluEh)
                        .toString();

                    return {
                        id: b.sqId,
                        documentName: b.belgeAdi,
                        isRequired: ["E"].includes(zorunlu),
                        fileName: "",
                        file: null,
                    };
                });


                setDocuments(list);
            })
            .catch((err: any) => {
                console.error("Belge listesi hatası:", err);
                setDocuments((prevDocs: any[]) =>
                    prevDocs.map((doc) => ({
                        ...doc,
                        file: null,
                        fileName: "",
                    }))
                );
            })
            .finally(() => {
                setDocsLoaded(true);
            });
    }, []);

    useEffect(() => {
        const fetchSabitler = async () => {
            try {
                const response = await WebSabitler.getWebSabitler();
                if (response?.data?.yeniAbonlkMesafeliSozlesmeBase64) {
                    setMesafeliSozlesmeBase64(response.data.yeniAbonlkMesafeliSozlesmeBase64);
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchSabitler();
    }, []);

    const navigate = useNavigate();
    useEffect(() => {
        if (!user) {
            setUserControlPopup(true);
        } else {
            setIsLoad(false);
        }
    }, [user]);
    const closeUserControlPopup = () => {
        setUserControlPopup(false);
        navigate(-1);
    };


    const [suNumaratajEh, setSuNumaratajEh] = useState(undefined);

    const [open, setOpen] = useState(false);

    const [selectedAkilliSayacTuru, setSelectedAkilliSayacKodu] = useState<any>(-1);
    const [selectedSayacYerKodu, setSelectedSayacYerKodu] = useState<number | null>(null);
    const [daskPoliceBitisTarihi, setDaskPoliceBitisTarihi] = useState<any>();
    const ClearAll = () => {
        setSelectedBolgeKodu(-1);
        setSelectedMahalleKodu(-1);
        setSelectedCaddeSokak(-1);
        setKapiNo(-1);
        setSelectedAboneTipiKodu(-1);
        setSelectedSayacMarkaKodu(-1);
        setSelectedSayacYerKodu(null);
        setAda("");
        setParsel("");
        setAltKapiNo("");
        setDaireNo("");
        setAltDaireNo("");
        setBlokNo("");
        setKatNo("");
        setSiteApartmanAdi("");
        setPafta("");
        setDamgaYili(-1);
        setSayacSeriNo("");
        setAciklama("");
        setDaskPoliceBilgisi(2)
        setDaskPoliceNo("")
        setDaskPoliceBitisTarihi(null)
        setDaskPoliceBaslangicTarihi(null)
        setSozlesmeOnaylandi(false)


    }
    //YeniAbonelikSaveAPI
    const fetchData = async (isPass: boolean = true) => {
        console.log("api çalıştı");
        setIsSubmitted(true)

        const missingDocuments = documents
            .filter(doc => doc.isRequired) // zorunlu belgeler
            .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
            const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
            toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
            documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
            toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
            return;
        }

        setLoadingSubmit(true);
        if (selectedBolgeKodu != -1 && selectedMahalleKodu != -1 && selectedCaddeSokak != -1 && kapiNo != -1 && selectedAboneTipiKodu != -1
            && selectedSayacMarkaKodu != -1
        ) {
            if (((daskPoliceBilgisi == 1 && daskPoliceBaslangicTarihi != null && daskPoliceBitisTarihi != null && daskPoliceNo != "") || daskPoliceBilgisi == 2)) {

                if (mesafeliSozlesmeBase64 && !sozlesmeOnaylandi) {
                    toast.error("Lütfen mesafeli sözleşmeyi okuyup onaylayınız.");
                    recaptchaRef.current?.reset();
                    setLoadingSubmit(false);
                    return;
                }

                YeniAbonelikBasvuruAPI.saveYeniAbonelikBasvuruSave(
                    new YeniAbonelikSaveRequest(
                        user?.sicilKodu,
                        300,
                        selectedBolgeKodu,
                        selectedMahalleKodu,
                        selectedCaddeSokak,
                        kapiNo,
                        selectedAboneTipiKodu,
                        undefined,
                        undefined,
                        Number(ada) || undefined,
                        Number(parsel) || undefined,
                        altKapiNo,
                        Number(daireNo) || undefined,
                        altDaireNo,
                        blokNo,
                        katNo,
                        siteApartmanAdi,
                        pafta,
                        damgaYili,
                        selectedSayacMarkaKodu == -1 ? undefined : selectedSayacMarkaKodu,
                        sayacSeriNo || undefined,
                        undefined,
                        selectedSayacYerKodu == null ? undefined : selectedSayacYerKodu,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        Number(daskPoliceNo) || undefined,
                        daskPoliceBaslangicTarihi,
                        daskPoliceBitisTarihi,
                        aciklama,
                        token)

                )
                    .then(async (response) => {
                        if (response.data.sonuc === 0) {
                            let basvuruNo = response.data.basvuruNo;

                            // DYS API'yi çağır 
                            try {
                                // Sadece dosyası olanları al
                                const filesToSend = documents.filter((doc: any) => !!doc.file);

                                if (filesToSend.length > 0) {
                                    const formData = new FormData();

                                    filesToSend.forEach((doc: any) => {
                                        formData.append("files", doc.file, doc.file.name);
                                        formData.append("rfObBasvuruTanimBelge", String(doc.id));
                                    });
                                    
                                    formData.append("basvuruTuru", String(300));
                                    formData.append("basvuruId", String(basvuruNo));
                                    formData.append("folderName", "AKOS");
                                    formData.append("kurumId", "1");
                                    formData.append("versionable", "1");

                                    const response = await DysAPI.upload(formData);
                                    toast.warning(response.message);
                                } else {
                                    // Burada return yok — sadece DYS çağrısını atlıyoruz.
                                    
                                }
                            } catch (error: any) {
                                toast.error("DYS upload hazırlama hatası:", error);
                            }



                            setPopupAciklama(
                                "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
                                basvuruNo
                            );
                            //resetForm();
                            setDocuments((prevDocs: any[]) =>
                                prevDocs.map((doc) => ({
                                    ...doc,
                                    file: null,
                                    fileName: "",
                                }))
                            );
                            setKayitBasarili(true);
                            setIsSubmitted(false);
                            ClearAll();
                        } else {
                            setPopupAciklama(response.data.sonucAciklama);
                            setIsSubmitted(false);
                        }
                    })
                    .catch((error) => {
                        showToast(
                            "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz.",
                            "error"
                        );
                    })
                    .finally(() => {
                        setIsPopupVisible(true);
                        recaptchaRef.current?.reset();
                        setLoadingSubmit(false);
                    });
            } else {
                focusInvalidInput()
                showToast(
                    "Lütfen zorunlu alanları doldurunuz.",
                    "error"
                );
                recaptchaRef.current?.reset();
                setLoadingSubmit(false); 
            }
        }
        else {
            focusInvalidInput()
            showToast(
                "Lütfen zorunlu alanları doldurunuz.",
                "error"
            );
            recaptchaRef.current?.reset();
            setLoadingSubmit(false);
        }
        console.log(isSubmitted)
    }
    //Kriter Bul API
    useEffect(() => {
        if (
            selectedKullanimSekliKodu != -1 &&
            selectedKullanimSekliKodu != undefined
        ) {
            CtvKriterBulAPI.getCtvKriterBul(selectedKullanimSekliKodu)
                .then((response) => {
                    setKriterBulAPIResponse(response.data[0]);
                    setKriterKodu(response.data[0].kriterKodu);
                })
                .catch((error) => {
                });
        }
    }, [selectedKullanimSekliKodu]);
    //SuSabit Bilgi Get API
    useEffect(() => {
        if (user) {
            SuSabitBilgiGetAPI.getSuSabitBilgiGet().then((res) => {
                setSuNumaratajEh(res.data[0].suNumaratajEh);
            }).catch((err) => {
            });
        }
    }, []);
    //Combo Apileri
    useEffect(() => {
        if (selectedBolgeKodu) {
            MahalleListeAPI.getMahalleListe(selectedBolgeKodu, undefined)
                .then((res) => {
                    setMahalleListe(res.data);
                })
                .catch(() => {
                    console.log("hata");
                });
        } else {
            setMahalleListe([]);
        }
    }, [selectedBolgeKodu]);
    useEffect(() => {
        if (suNumaratajEh != undefined && suNumaratajEh == 'E') {
            setKapiNo(-1);
        } else {
            setKapiNo(-1)
        }
    }, [suNumaratajEh]);
    useEffect(() => {
        if (selectedMahalleKodu) {
            CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
                .then((res) => {
                    setCaddeListe(res.data);
                })
                .catch(() => {
                    console.log("hata");
                });
        } else {
            setCaddeListe([]);
        }
    }, [selectedMahalleKodu]);

    useEffect(() => {
        if (suNumaratajEh == "E" && selectedMahalleKodu !== -1 && selectedCaddeSokak !== -1) {
            NumaratajKapiListeAPI.geNumaratajKapiListeListe(selectedMahalleKodu || 0, selectedCaddeSokak || 0).then((res) => {

                setNumaratajKapiListeDatas(res.data);

            }).catch((err) => {
            });
        }
    }, [suNumaratajEh, selectedMahalleKodu, selectedCaddeSokak]);
    useEffect(() => {
        if (user) {
            AboneTipiListeAPI.getAboneTipiListe()
                .then((res) => {
                    setAboneTipiDatas(res.data);
                })
                .catch((err) => {
                });
        }
    }, []);
    useEffect(() => {
        if (user) {
            AkilliSayacListeAPI.getAkilliSayacListe(undefined)
                .then((res) => {
                    setAkilliSayacMarkaDatas(res.data);
                })
                .catch((err) => {
                });
        }
    }, []);
    useEffect(() => {
        if (user) {
            SayacMarkaListeAPI.getSayacMarkaListe()
                .then((res) => {
                    setSayacMarkaDatas(res.data);
                })
                .catch((err) => {
                });
        }
    }, []);
    useEffect(() => {
        if (user) {
            SayacYeriListeAPI.getSayacYeriListe()
                .then((res) => {
                    setSayacYeriDatas(res.data);
                    console.log(res.data)
                })
                .catch((err) => {
                });
            console.log("Success")
        }

    }, []);
    useEffect(() => {
        if (user) {
            KullanimSekliAPI.getKullanimSekliListe(undefined)
                .then((res) => {
                    setKullanimSekliDatas(res.data);
                })
                .catch((err) => {
                });
        }
    }, []);
    useEffect(() => {
        if (
            selectedKullanimSekliKodu != -1 &&
            selectedKullanimSekliKodu != undefined
        ) {
            CtvKriterBulAPI.getCtvKriterBul(selectedKullanimSekliKodu)
                .then((response) => {
                    setKriterBulAPIResponse(response.data[0]);
                    setKriterKodu(response.data[0].kriterKodu);
                })
                .catch((error) => {
                });
        }
    }, [selectedKullanimSekliKodu]);

    //Kriter Temizleme effect
    useEffect(() => {
        setM2("")
        setOgrenciSayisi("")
        setKoltukSayisi("")
        setPersonelSayisi("")
        setYatakSayisi("")
    }, [kriterKodu])

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return isLoad ? <>
        <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
        {userControlPopup ? (

            <AciklamaAndUserControlPopup
                open={userControlPopup}
                handleClose={closeUserControlPopup}
                isUserControlPopUp={true}
                description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
            />

        ) : null}
    </> : (<>
        <Formik
            initialValues={initialValues}
            onSubmit={() => { }}>
            {(formikProps) => {
                return (
                    <Form onSubmit={formikProps.handleSubmit}>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <div className="d-flex justify-content-end align-self-stretch">
                                    <Button
                                        type="button"
                                        variant="contained"
                                        onClick={() => {
                                            formikProps.resetForm({ values: formikProps.initialValues });
                                            setDocuments((prevDocs: any[]) =>
                                                prevDocs.map((doc) => ({
                                                    ...doc,
                                                    file: null,
                                                    fileName: "",
                                                }))
                                            );
                                            ClearAll();
                                            setIsSubmitted(false);
                                        }}
                                        color="secondary"
                                    >
                                        Temizle
                                    </Button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3 mb-lg-0">
                                <div className="card shadow-none border w-100">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <CustomTextField
                                                    name="bolgeKodu"
                                                    fullWidth
                                                    className="mb-3"
                                                    select
                                                    label="Bölge Adı *"
                                                    size="small"
                                                    value={selectedBolgeKodu}
                                                    onChange={(e: any) => {
                                                        setSelectedBolgeKodu(Number(e.target.value));
                                                    }}
                                                    error={isSubmitted && selectedBolgeKodu == -1}


                                                >
                                                    <MenuItem selected value={-1 as any}>
                                                        {"Seçiniz.."}
                                                    </MenuItem>
                                                    {
                                                        bolgeListe.map((option) => (
                                                            <MenuItem key={option.bolgeKodu} value={option.bolgeKodu}>
                                                                {option.bolgeAdi}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </CustomTextField>
                                            </div>
                                            <div className="col-lg-6">
                                                <CustomTextField
                                                    name="mahalleKodu"
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    select
                                                    label="Mahalle *"
                                                    value={selectedMahalleKodu}
                                                    onChange={(e: any) => {
                                                        setSelectedMahalleKodu(Number(e.target.value));
                                                    }}
                                                    error={isSubmitted && selectedMahalleKodu == -1}
                                                >
                                                    <MenuItem selected value={-1 as any}>
                                                        {"Seçiniz.."}
                                                    </MenuItem>
                                                    {mahalleListe.map((option) => (
                                                        <MenuItem key={option.mahalleKodu} value={option.mahalleKodu}>
                                                            {option.mahalleAdi}
                                                        </MenuItem>
                                                    ))}
                                                </CustomTextField>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <CustomTextField
                                                    name="caddeSokakKodu"
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    select
                                                    label="Cadde/Sokak *"
                                                    value={selectedCaddeSokak}
                                                    onChange={(e: any) => {
                                                        setSelectedCaddeSokak(Number(e.target.value));
                                                    }}
                                                    error={isSubmitted && selectedCaddeSokak == -1}
                                                >
                                                    <MenuItem selected value={-1 as any}>
                                                        {"Seçiniz.."}
                                                    </MenuItem>
                                                    {caddeListe.map((option) => (
                                                        <MenuItem key={option.caddeSokakKodu} value={option.caddeSokakKodu}>
                                                            {option.caddeSokakAdi}
                                                        </MenuItem>
                                                    ))}
                                                </CustomTextField>
                                            </div>
                                            <div className="col-lg-6">
                                                {suNumaratajEh != undefined && suNumaratajEh == 'E' ?
                                                    <CustomTextField
                                                        name="kapiNo"
                                                        fullWidth
                                                        className="mb-3"
                                                        size="small"
                                                        select
                                                        label="Kapı No *"
                                                        value={kapiNo}
                                                        onChange={(e: any) => setKapiNo(e.target.value)}
                                                        error={isSubmitted && kapiNo == -1}
                                                    >
                                                        <MenuItem selected value={-1 as any}>
                                                            {"Seçiniz.."}
                                                        </MenuItem>
                                                        {numaratajKapiListeDatas.map((option) => (
                                                            <MenuItem key={option.kapiNo} value={option.kapiNo}>
                                                                {option.kapiNo}
                                                            </MenuItem>
                                                        ))}
                                                    </CustomTextField> :
                                                    <CustomTextField
                                                        fullWidth
                                                        name="kapiNo"
                                                        className="mb-3"
                                                        size="small"
                                                        label="Kapı No *"
                                                        value={kapiNo == -1 ? "" : kapiNo}
                                                        onChange={(e: any) => setKapiNo(e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : -1)}
                                                        error={isSubmitted && kapiNo == -1}
                                                    >
                                                    </CustomTextField>
                                                }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Alt Kapı No"
                                                    value={altKapiNo}
                                                    onChange={(e) => setAltKapiNo(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Daire No"
                                                    value={daireNo || ""}
                                                    onChange={(e) => setDaireNo(e.target.value)}
                                                    variant="outlined"

                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Blok No"
                                                    value={blokNo}
                                                    onChange={(e) => setBlokNo(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Kat No"
                                                    value={katNo} onChange={(e) => setKatNo(e.target.value)}
                                                    variant="outlined"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Site Apartman Adı"
                                                    value={siteApartmanAdi}
                                                    onChange={(e) => setSiteApartmanAdi(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Pafta"
                                                    value={pafta} onChange={(e) => setPafta(e.target.value)}
                                                    variant="outlined"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Ada"
                                                    value={ada}
                                                    onChange={(e) => setAda(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Parsel"
                                                    value={parsel || ""}
                                                    onChange={(e) => setParsel(e.target.value)}
                                                    variant="outlined"

                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <CustomTextField
                                                    name="aboneTipiKodu"
                                                    fullWidth
                                                    className="mb-3"
                                                    select
                                                    label="Abone Tipi *"
                                                    size="small"
                                                    value={selectedAboneTipiKodu}
                                                    onChange={(e: any) => {
                                                        setSelectedAboneTipiKodu(Number(e.target.value));
                                                    }}
                                                    error={isSubmitted && selectedAboneTipiKodu == -1}


                                                >
                                                    <MenuItem selected value={-1 as any}>
                                                        {"Seçiniz.."}
                                                    </MenuItem>
                                                    {
                                                        aboneTipiDatas.map((option) => (
                                                            <MenuItem key={option.aboneTipiKodu} value={option.aboneTipiKodu}>
                                                                {option.aboneTipiAdi}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </CustomTextField>
                                            </div>
                                            <div className="col-lg-6">
                                                <CustomTextField
                                                    name="sayacMarkaKodu"
                                                    fullWidth
                                                    className="mb-3"
                                                    select
                                                    label="Sayaç Markası *"
                                                    size="small"
                                                    value={selectedSayacMarkaKodu}
                                                    onChange={(e: any) => {
                                                        setSelectedSayacMarkaKodu(Number(e.target.value));
                                                    }}
                                                    error={isSubmitted && selectedSayacMarkaKodu == -1}
                                                >
                                                    <MenuItem selected value={-1}>
                                                        {"Seçiniz.."}
                                                    </MenuItem>
                                                    {
                                                        sayacMarkaDatas.map((option) => (
                                                            <MenuItem key={option.sayacMarkaKodu} value={option.sayacMarkaKodu}>
                                                                {option.sayacMarkaAdi}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </CustomTextField>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <TextField
                                                    name="sayacSeriNo"
                                                    fullWidth
                                                    className="mb-3"
                                                    size="small"
                                                    label="Sayaç Seri No"
                                                    value={sayacSeriNo}
                                                    onChange={(e: any) => setSayacSeriNo(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    select
                                                    label="Sayaç Yeri"
                                                    size="small"
                                                    value={selectedSayacYerKodu ?? ""}
                                                    onChange={(e: any) => {
                                                        const v = e.target.value;
                                                        setSelectedSayacYerKodu(v === "" ? null : Number(v));
                                                    }}
                                                >
                                                    <MenuItem selected value="">
                                                        {"Seçiniz.."}
                                                    </MenuItem>
                                                    {
                                                        sayacYeriDatas.map((option) => (
                                                            <MenuItem key={option.sayacYerKodu} value={option.sayacYerKodu}>
                                                                {option.sayacYerAdi}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </TextField>
                                            </div>
                                        </div>
                                        <div className="row mb-3 mb-lg-0">
                                            <div className="col-lg-6">
                                                <TextField
                                                    fullWidth
                                                    className="mb-3"
                                                    select
                                                    label="Damga Yılı"
                                                    size="small"
                                                    value={damgaYili}
                                                    onChange={(e) => setDamgaYili(Number(e.target.value))}
                                                >
                                                    <MenuItem selected value={-1 as any}>
                                                        {"Seçiniz.."}
                                                    </MenuItem>
                                                    {
                                                        yilListe.map((option) => (
                                                            <MenuItem key={option.yili} value={option.yili}>
                                                                {option.yili}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </TextField>
                                            </div>
                                            <div className="col-lg-6">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-lg-0">
                                <div className="card shadow-none border w-100">
                                    <div className="card-body">

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <CustomTextField
                                                    fullWidth
                                                    className="mb-3"
                                                    select
                                                    label="Dask Poliçe Bilgisi *"
                                                    size="small"
                                                    value={daskPoliceBilgisi} onChange={(e: any) => setDaskPoliceBilgisi(Number(e.target.value))}
                                                >
                                                    <MenuItem value={1}>{"Var"}</MenuItem>
                                                    <MenuItem value={2}>{"Yok"}</MenuItem>
                                                </CustomTextField>
                                            </div>
                                            <div className="col-lg-6">
                                                <CustomTextField
                                                    name="daskPoliceNo"
                                                    disabled={daskPoliceBilgisi == 1 ? false : true}  // Buradaki "koşul" boolean bir ifade olmalıdır.
                                                    fullWidth
                                                    className="mb-3"
                                                    label="Dask Poliçe No *"
                                                    size="small"
                                                    value={daskPoliceNo}
                                                    onChange={(e: any) => setDaskPoliceNo(e.target.value)}
                                                    error={isSubmitted && daskPoliceNo == 1 && daskPoliceNo == ""}

                                                >
                                                </CustomTextField>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <CustomDatePicker
                                                    name="daskPoliceBaslangicTarihi"
                                                    disabled={daskPoliceBilgisi == 1 ? false : true}  // Buradaki "koşul" boolean bir ifade olmalıdır.
                                                    slotProps={{
                                                        textField: {
                                                            size: "small",
                                                            fullWidth: true,
                                                            color: isSubmitted && daskPoliceBilgisi == 1 && daskPoliceBaslangicTarihi == null ? "error" : "primary"
                                                        }
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                                        },
                                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: isSubmitted && daskPoliceBilgisi == 1 && daskPoliceBaslangicTarihi == null ? '1px solid #C7214C' : '' },
                                                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: isSubmitted && daskPoliceBilgisi == 1 && daskPoliceBaslangicTarihi == null ? '1px solid #C7214C' : '' },
                                                    }}
                                                    label="Dask Poliçe Başlangıç Tarihi *"
                                                    value={daskPoliceBaslangicTarihi}
                                                    onChange={(newValue: any) => {
                                                        setDaskPoliceBaslangicTarihi(newValue);
                                                    }}

                                                    className="mb-3" />
                                            </div>
                                            <div className="col-lg-6">
                                                <CustomDatePicker
                                                    name="daskPoliceBitisTarihi"
                                                    disabled={daskPoliceBilgisi == 1 ? false : true}  // Buradaki "koşul" boolean bir ifade olmalıdır.
                                                    slotProps={{
                                                        textField: {
                                                            size: "small",
                                                            fullWidth: true,
                                                            color: isSubmitted && daskPoliceBilgisi == 1 && daskPoliceBitisTarihi == null ? "error" : "primary"
                                                        },
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                                        },
                                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: isSubmitted && daskPoliceBilgisi == 1 && daskPoliceBitisTarihi == null ? '1px solid #C7214C' : '' },
                                                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: isSubmitted && daskPoliceBilgisi == 1 && daskPoliceBitisTarihi == null ? '1px solid #C7214C' : '' },
                                                    }}
                                                    label="Dask Poliçe Bitiş Tarihi *"
                                                    value={daskPoliceBitisTarihi}
                                                    onChange={(newValue: any) => {
                                                        setDaskPoliceBitisTarihi(newValue);
                                                    }}
                                                    className="mb-3" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <TextField
                                                    id="outlined-multiline-flexible"
                                                    label="Açıklama"
                                                    value={aciklama}
                                                    onChange={(event) => setAciklama(event.target.value)}
                                                    rows={8.9}
                                                    fullWidth
                                                    multiline
                                                    maxRows={10}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {mesafeliSozlesmeBase64 && (
                                <div className="col-12 mt-3 mb-2">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={sozlesmeOnaylandi}
                                                color="primary"
                                                readOnly
                                            />
                                        }
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (mesafeliSozlesmeBase64) {
                                                const byteCharacters = atob(mesafeliSozlesmeBase64);
                                                const byteNumbers = new Array(byteCharacters.length);
                                                for (let i = 0; i < byteCharacters.length; i++) {
                                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                }
                                                const byteArray = new Uint8Array(byteNumbers);
                                                const blob = new Blob([byteArray], { type: 'application/pdf' });
                                                const url = window.URL.createObjectURL(blob);
                                                setSozlesmePdfUrl(url);
                                                setSozlesmePopupOpen(true);
                                            }
                                        }}
                                        sx={{ cursor: 'pointer' }}
                                        label={
                                            <span>
                                                <Link
                                                    component="span"
                                                    underline="always"
                                                >
                                                    Mesafeli Sözleşme
                                                </Link>
                                                'yi okudum ve kabul ediyorum.
                                            </span>
                                        }
                                    />
                                    {isSubmitted && !sozlesmeOnaylandi && (
                                        <span style={{ color: '#d32f2f', fontSize: '0.75rem', display: 'block', marginLeft: 32 }}>
                                            Mesafeli sözleşmeyi onaylamanız gerekmektedir.
                                        </span>
                                    )}
                                </div>
                            )}
                            <div ref={documentTableRef}>
                                {!docsLoaded ? (
                                    <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                                ) : (
                                    <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                                )}
                            </div>
                            <div className="col-12 mt-2">
                                <div className="d-flex justify-content-end align-self-stretch">
                                    <Recaptcha
                                        ref={recaptchaRef}
                                        changeHandleRecaptcha={setRecaptchaPassed}
                                    />
                                    <Button
                                        onClick={() => fetchData()}
                                        variant="contained"

                                    >
                                        Gönder
                                    </Button>
                                    {loadingSubmit && (
                                        <div
                                            style={{
                                                position: "fixed",
                                                inset: 0,
                                                background: "rgba(255,255,255,0.6)",
                                                zIndex: 1300,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <CircularProgress />
                                        </div>
                                    )}
                                </div>
                            </div>
                            {isPopupVisible ? (
                                <BilgilendirmePopup
                                    basvuruTuruId={300}
                                    isSorunBildirPopup={!kayitBasarili}
                                    closePopup={closePopupSonuc}
                                    open={isPopupVisible}
                                    editDescription={popupAciklama}
                                />
                            ) : null}
                        </div>
                    </Form>
                );
            }}
        </Formik >
        <Dialog
            open={sozlesmePopupOpen}
            onClose={handleCloseSozlesmePopup}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Mesafeli Sözleşme
                <IconButton onClick={handleCloseSozlesmePopup}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent
                onScroll={handleSozlesmeScroll}
                dividers
                sx={{ maxHeight: '65vh', p: 0 }}
            >
                {sozlesmePdfUrl && (
                    <div style={{ overflow: 'hidden', width: '100%', height: '800px' }}>
                        <iframe
                            src={`${sozlesmePdfUrl}#toolbar=0&navpanes=0`}
                            width="100%"
                            style={{ border: 'none', height: 'calc(100% + 52px)', marginTop: '-52px' }}
                            title="Mesafeli Sözleşme"
                        />
                    </div>
                )}
                <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }}>
                    Sözleşmenin tamamını okuduktan sonra onaylayabilirsiniz.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button
                    disabled={!sozlesmeScrolledToBottom}
                    onClick={() => {
                        setSozlesmeOnaylandi(true);
                        handleCloseSozlesmePopup();
                    }}
                    variant="contained"
                    color="primary"
                >
                    Okudum ve Onaylıyorum
                </Button>
            </DialogActions>
        </Dialog>
        </>
    );
};

export default YeniAbonelik;